module.exports = __webpack_public_path__ + "fonts/fd287862/proxima_nova_reg-latin-a.eot";